import type { Country } from '../../constants/country/country';
import { PaymentMethod, ShippingMethodId } from '../../constants/woocommerce/woocommerce';

export interface BillingAddress {
  firstName: string;
  lastName: string;
  company?: string;
  address1: string;
  address2?: string;
  city: string;
  state: string;
  postcode: string;
  country: Country;
  email: string;
  phone: string;
}

export interface ShippingAddress {
  firstName: string;
  lastName: string;
  company?: string;
  address1: string;
  address2?: string;
  city: string;
  state: string;
  postcode: string;
  country: Country;
}

export interface WooCommerceLineItem {
  productId: number;
  variationId?: number;
  quantity: number;
}

export interface ShippingLine {
  methodId: ShippingMethodId;
  methodTitle: string;
  total: string;
}

export interface OrderMetaDataResponse {
  id: number;
  key: string;
  value: string;
}

export interface OrderTaxResponse {
  id: number;
  total: string;
  subtotal: string;
}

export interface OrderLineItemResponse {
  id: number;
  name: string;
  productId: number;
  variationId: number;
  quantity: number;
  taxClass: string;
  subtotal: string;
  subtotalTax: string;
  total: string;
  totalTax: string;
  taxes: OrderTaxResponse[];
  metaData: OrderMetaDataResponse[];
  sku: string;
  price: number;
}

export interface OrderTaxLineResponse {
  id: number;
  rateCode: string;
  rateId: number;
  label: string;
  compound: boolean;
  taxTotal: string;
  shippingTaxTotal: string;
  metaData: OrderMetaDataResponse[];
}

export interface OrderShippingLineResponse {
  id: number;
  methodTitle: string;
  methodId: string;
  total: string;
  totalTax: string;
  taxes: OrderTaxResponse[];
  metaData: OrderMetaDataResponse[];
}

export interface OrderLinks {
  self: string[];
  collection: string[];
}

export interface WooCommerceOrderResponse {
  id: number;
  parentId: number;
  number: string;
  orderKey: string;
  createdVia: string;
  version: string;
  status: string;
  currency: string;
  dateCreated: string;
  dateCreatedGmt: string;
  dateModified: string;
  dateModifiedGmt: string;
  discountTotal: string;
  discountTax: string;
  shippingTotal: string;
  shippingTax: string;
  cartTax: string;
  total: string;
  totalTax: string;
  pricesIncludeTax: boolean;
  customerId: number;
  customerIpAddress: string;
  customerUserAgent: string;
  customerNote: string;
  billing: BillingAddress;
  shipping: ShippingAddress;
  paymentMethod: PaymentMethod;
  paymentMethodTitle: string;
  transactionId: string;
  datePaid?: string;
  datePaidGmt?: string;
  dateCompleted?: string;
  dateCompletedGmt?: string;
  cartHash: string;
  metaData: OrderMetaDataResponse[];
  lineItems: OrderLineItemResponse[];
  taxLines: OrderTaxLineResponse[];
  shippingLines: OrderShippingLineResponse[];
  feeLines: string[];
  couponLines: string[];
  refunds: string[];
  links: OrderLinks;
}
